import PropTypes from 'prop-types'
import React from 'react'
import { getFavoriteStation, setStation } from '../../actions/contentActions.js'
import focusable from '../../components/Focusable/Focusable'
import { store } from '../../store'
import tts from '../../lib/TTS'
import {
  platformStoreGet,
  triggerSentryError,
  ComcastErrorType,
} from '../../../../shared/helpers.js'
import { getStationDonationAmountsHelper } from '../../actions/tvaultActions.js'
import googleAnalytics4 from '../../lib/googleAnalytics.js'
import { withRouter } from '../../../../shared/components/WithRouter/WithRouter'

export class StationCarouselItem extends React.Component {
  constructor(props) {
    super(props)
    this.componentType = 'stationCarouselItem'
    this.stationItemRef = React.createRef()
  }

  onKeyEvent(key) {
    let handled = false

    if ('ENTER' === key) {
      this.stationItemRef.current.click()
    }

    return handled
  }

  setStation(guid) {
    setStation(guid)
      .then(() => {
        getFavoriteStation(platformStoreGet('uID-ga')).then((data) => {
          store.dispatch({
            type: 'UPDATE_STATION',
            payload: data,
          })

          googleAnalytics4.setUserProperty(
            'station_localization',
            data.call_sign
          )

          store.dispatch({
            type: 'UPDATE_USER_STATION',
            payload: data.call_sign,
          })

          // Reset/Nullify Home Content so Home page can refresh when it mounts
          store.dispatch({
            type: 'SET_HOME_CONTENT',
            payload: { collections: null },
          })
          if (COMPILING_FOR_COMCASTX1 && COMCAST_IN_APP_DONATIONS_ENABLED) {
            getStationDonationAmountsHelper(data.call_sign)
          }

          this.props.router.navigate(-1)
        })
      })
      .catch((err) => {
        triggerSentryError('setStation', 'StationCarouselItem.js', {
          errorMessage: err.message ?? 'Undefined error message (default)',
          guid,
          errorLocation: 'StationCarouselItem - setStation',
          errorType: ComcastErrorType.other,
        })
      })
  }

  readText() {
    const { index, itemCount, title, address } = this.props

    // we do this substring stuff so chromevox on vizio can announce consonant/vowel pairs i.e. 'VA' properly
    let addressLength = address.length
    let formattedAddress =
      address.substring(0, addressLength - 1) +
      '.' +
      address.substring(addressLength - 1)

    tts.addTextToRead([`${index + 1} of ${itemCount}`, title, formattedAddress])
  }
  render() {
    const { hasFocus, title, address, cid } = this.props

    return (
      <div
        className={`station-item-wrapper ${hasFocus ? 'focused' : ''}`}
        ref={this.stationItemRef}
        onClick={() => {
          this.setStation(cid)
        }}
      >
        <div className="station-item-title">{title}</div>
        <div className="station-item-address">{address}</div>
      </div>
    )
  }
}

StationCarouselItem.propTypes = {
  title: PropTypes.string,
  address: PropTypes.string,
  cid: PropTypes.string,
  hasFocus: PropTypes.bool,
  router: PropTypes.shape({
    navigate: PropTypes.func,
  }),
  index: PropTypes.number,
  itemCount: PropTypes.number,
}

export default withRouter(focusable(StationCarouselItem))
